/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vbWFpbnRlbmFuY2VzL2RpYWxvZ3MvZGlhbG9nLWVkaXQtbWFpbnRlbmFuY2UvdGFicy9wZW5kZW5jaWVzL2NvbXBvbmVudHMvdXBkYXRlLWFzc2lnbmVlLW1vZGFsL3VwZGF0ZS1hc3NpZ25lZS1tb2RhbC5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
